<template>
    <div id="searchModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Search NPI Registry</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                    
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-row">
                        <div class="mr-1">
                            <select id="npi_type" class="custom-select" name="npi_type" v-model="type">
                                <option value="Any" selected>NPI Number</option>
                                <option value="NPI-1" selected>Individual</option>
                                <option value="NPI-2">Organization</option>
                            </select>                            
                        </div>
                        <div class="mr-1">
                            <input v-show="type == 'Any'" id="npi" type="text" class="form-control" name="npi" placeholder="Enter NPI Number" v-model="npi">
                            <input v-show="type == 'NPI-1'" id="individual_name" type="text" class="form-control" name="individual_name" placeholder="Enter Name" v-model="individualName">
                            <input v-show="type == 'NPI-2'" id="organization_name" type="text" class="form-control" name="organization_name" placeholder="Enter Organization Name" v-model="organizationName">
                        </div>
                        <div>
                            <button id="search" type="button" class="btn btn-primary" @click="onSearch">Search</button>
                        </div>
                    </div>
                    <div class="mt-3">
                        <div v-if="isSearching" class="text-center"><i class="fas fa-spinner fa-spin text-muted"></i></div>                        
                        <div v-else-if="providers.length > 0" class="list-group">
                            <button type="button" class="list-group-item list-group-item-action" v-for="provider in providers" :key="provider.number" @click="addProvider(provider)" v-html="getName(provider)"></button>
                        </div>                        
                        <div v-else class="h3 text-muted text-center border-top pt-3">No Results</div> 
                    </div>                     
                </div>
                <div class="modal-footer">
                    <nav aria-label="Page navigation">
                        <ul class="pagination">
                            <li v-bind:class="['page-item', { 'disabled' : page == 0 }]">
                                <a class="page-link" href="#" @click="onSearch">
                                    <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                                </a>
                            </li>
                            <li v-bind:class="['page-item', { 'disabled' : providers && providers.length < 10 }]">
                                <a class="page-link" href="#" @click="onSearch">
                                    <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            clientId: null,
            type: 'Any',
            npi: '',
            individualName: '',
            organizationName: '',
            providers: [],
            page: 0,
            isSearching: false
        } 
    },
    methods: {
        showModal: function (clientId) {
            this.clientId = clientId;
            $('#searchModal').modal('show');
        },
        hideModal: function () {
            $('#searchModal').modal('hide');
        },
        onSearch: function (e) {
            var self = this;

            if (e.target.id == 'search') {
                self.providers = [];
                self.page = 0;
            }
            else if (e.target.id == 'next') {
                (self.providers.length < 10) ? null : self.page++;
            }
            else if (e.target.id == 'previous') {
                (self.page > 0) ? self.page-- : null;
            }

            this.isSearching = true;

            axios.get('/ajax/npi/search', {
                params: {
                    'npi_type': self.type,
                    'npi': self.npi,
                    'individual_name': self.individualName,
                    'organization_name': self.organizationName, 
                    'page': self.page
                }     
            })
            .then(response => {
                self.providers = response.data.results;
                this.isSearching = false;
            })
            .catch(error => {
                // TODO: handle errors with toastr
                this.isSearching = false;
            });            
        },
        addProvider: function(provider) {
            var self = this;
            axios.post('/ajax/npi/add', {
                'provider': provider,
                'client_id': self.clientId,
            })
            .then(response => {
                eventHub.$emit('refresh-providers', response.data.npi);
            })
            .catch(error => {
                // TODO: handle errors with toastr
            });

            this.hideModal();
        },
        getName: function(provider) {
            var result = '<span class="mr-3">' + provider.number + '</span>';
            if (provider.enumeration_type == 'NPI-1') {
                result += (provider.basic.first_name ? provider.basic.first_name + ' ' : '') +
                         (provider.basic.middle_name ? provider.basic.middle_name + ' ' : '') + 
                         provider.basic.last_name + 
                         (provider.basic.credential ? ' ' + provider.basic.credential : '');
            }
            else if (provider.enumeration_type == 'NPI-2') {
                result += provider.basic.organization_name;
            }

            return result;
        },
    },
    mounted() {
        var self = this;
        $('#searchModal').on('hidden.bs.modal', function (e) {
            self.type = 'Any';
            self.npi = '';
            self.individualName = '';
            self.organizationName = '';
            self.providers = [];
            self.page = 0;
        });
    },
    created() {
        eventHub.$on('show-npi-search', this.showModal);
    },
    beforeDestroy() {
        eventHub.$off('show-npi-search');
    },    
}
</script>

<style>
    .chev-pos {
        position: relative;
        top: -3px;
        left: -3px;        
    }
</style>


